import { useQuery } from "@tanstack/react-query";
import api from "./api";

export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Yarra Valley · Victoria",
    line1: "Built with purpose.",
    line2: "Finished with precision.",
    sub: "Owner-operated residential carpentry and construction, established in the Yarra Valley and servicing surrounding areas including Maroondah and selected Melbourne suburbs.",
    image: "/work/verandah-finished.webp",
  },
  marquee: ["Residential Renovations", "Structural Carpentry", "Timber Framing", "Custom Decks",
    "Pergolas", "Verandahs", "Finish Carpentry", "Yarra Valley"],
  philosophy: {
    eyebrow: "Modern Heritage",
    title: "Traditional craft, built for the way you live today.",
    body: "Heritage Constructions delivers residential carpentry and construction with a focus on quality workmanship, attention to detail and lasting results. From structural alterations and renovations to outdoor structures and detailed finishes, every project is approached with care, precision and a commitment to quality.",
    signature: "Lucas — Owner-Operator, Heritage Constructions",
    image: "/work/framing-interior.webp",
  },
  process: [
    { n: "01", title: "Consultation & site visit", desc: "Tell us about your project aspirations, we will visit your property and talk through what is possible and what the next steps look like." },
    { n: "02", title: "Detailed written quote", desc: "You receive a clear quotation with complete transparency into materials, methods and timelines. Our priority is to work collaboratively with you to find the best solution suited to you." },
    { n: "03", title: "Careful construction", desc: "The owner is on the tools. Your site is kept tidy, your neighbours kept happy, and progress kept moving." },
    { n: "04", title: "Finish & handover", desc: "We walk through the finished work together. Details are perfected, the site is left clean, and the result is built to last." },
  ],
  services: [],
  work_intro: {
    eyebrow: "Our Work",
    title: "Built by hand. Judged up close.",
    sub: "A selection of recent projects: frames, structures and finished spaces. New work is added as projects are completed.",
  },
  before_after: {
    title: "From frame to finish",
    caption: "Verandah rebuild: structure first, then hardwood decking and steel balustrade. Slide to compare the same job during construction and at handover.",
    before_label: "On the frame",
    after_label: "Handed over",
    before_image: "",
    after_image: "/work/verandah-finished.webp",
  },
  about: {
    eyebrow: "About",
    title: "Established in the Yarra Valley.",
    story: [],
    values: [],
    areas: [],
    signature: "Lucas",
    signature_role: "Owner-Operator, Heritage Constructions",
    image: "/work/framing-interior.webp",
  },
  contact: {
    phone: "0456 492 849",
    email: "lucas@heritageconstructions.com.au",
    note: "Lucas personally reads and responds to every enquiry.",
    form_intro: "Tell us a little about your project and Lucas will be in touch to arrange a site visit.",
  },
};

export function useContent() {
  const { data } = useQuery({
    queryKey: ["content"],
    queryFn: async () => (await api.get("/content")).data,
    staleTime: 60_000,
  });
  if (!data) return null;
  return { ...DEFAULT_CONTENT, ...data };
}

export function useProjects() {
  return useQuery({
    queryKey: ["projects"],
    queryFn: async () => (await api.get("/projects")).data,
    staleTime: 60_000,
  });
}
